// extracted by mini-css-extract-plugin
export var assigneeBadge = "_mr-0";
export var assigneeDetails = "_mr-1";
export var assigneeInfo = "_mr-2";
export var dropdownContainer = "_mr-4";
export var dropdownImage = "_mr-5";
export var editAssigneeInfo = "_mr-3";
export var editAssigneeModalContainer = "_mr-6";
export var hidden = "_mr-8";
export var input = "_mr-7";